<template>
    <div class="sustainable-component wage-money-position-salary">

        <!--<div class="bg-success mb-3 p-3 rounded">vue component wage-money-position-salary</div>-->

        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-md-6 mb-5">
                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="doUpdate">
                        Uppdatera löneunderlag
                    </v-btn>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <a href="javascript:void(0)" @click="printBlockSalary">Visa översikt över utvecklingsblockens värde</a>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <v-radio-group v-bind:disabled="disabled" :model-value="calculationType" @update:model-value="changeType">
                        <v-radio data-testid="wage-money-position-salary-alt1" label="Alt 1. Alla utvecklingsblock får samma värde." value="0"></v-radio>
                        <v-radio data-testid="wage-money-position-salary-alt2" label="Alt 2. Utvecklingsblockens värde fastställs utan arbetsvärdering." value="1"></v-radio>
                        <v-radio data-testid="wage-money-position-salary-alt3" label="Alt 3. Utvecklingsblockens värde baseras på arbetsvärdering och poängintervall." value="2"></v-radio>
                        <v-radio data-testid="wage-money-position-salary-alt4" label="Alt 4. Utvecklingsblockens värde baseras på arbetsvärdering och kronor per poäng." value="3"></v-radio>
                    </v-radio-group>
                </div>
            </div>
            <div class="row" v-if="calculationType == '0'">

                <div class="col-12 col-md-6 mr-3">
                    <CommonLabelContainer title="Konstruktion">
                        <div class="container-fluid p-0">
                            <div class="row">
                                <div class="col-12">
                                    <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" label="Värde i kr" v-model="blockSalary" variant="outlined"></v-text-field>
                                </div>
                                <div class="col-12">
                                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="setBlockPartSalary">
                                        Beräkna värde
                                    </v-btn>
                                </div>
                            </div>

                        </div>
                    </CommonLabelContainer>
                </div>
            </div>
            <div class="row" v-if="calculationType == '1'">

                <div class="col-12 col-md-6 mr-3 mb-3">

                    <CommonLabelContainer title="Konstruktion">
                        <div class="container-fluid p-0">
                            <div class="row">
                                <div class="col-12">
                                    För att spara data klickar du antingen på ”Spara” som finns på respektive rad eller knappen
                                    "Skapa värden i lönesystemet" som finns under tabellen.

                                    <table class="table table-light table-hover table-striped">
                                        <thead class="thead-light">
                                            <tr>
                                                <th class="col-4">Befattning</th>
                                                <th class="col-2">Blocknr.</th>
                                                <th class="col-2">Blocknamn</th>
                                                <th class="col-2">Värde</th>
                                                <th class="col-2"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(positionBlock, index) in jobPositionsWithBlocks" :key="index">
                                                <td>{{positionBlock.JobPositionName}}</td>
                                                <td>{{positionBlock.BlockNumber}}</td>
                                                <td>{{positionBlock.Name}}</td>
                                                <td>
                                                    <v-text-field :decimal-sv="true" bg-color="white" v-model="positionBlock.Salary" hide-details="true" density="compact" variant="outlined"></v-text-field>
                                                </td>
                                                <td>
                                                    <div class="pull-right" style="" v-if="disabled == false">
                                                        <div class="dropdown text-right pr-2">
                                                            <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                                ...
                                                            </a>
                                                            <div class="dropdown-menu dropdown-menu-right">
                                                                <a href="javascript:void(0)" class="dropdown-item" @click="savePositionBlockSalary(positionBlock)">Spara</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <v-btn
                                        v-bind:disabled="disabled"
                                        size="default"
                                        color="primary"
                                        class="btn-primary"
                                        data-testid="wage-money-position-salary-bulk-save"
                                        @click="setAllSalaries">
                                        Skapa värden i lönesystemet
                                    </v-btn>
                                </div>
                            </div>
                        </div>

                    </CommonLabelContainer>
                </div>
            </div>

            <div class="row" v-if="calculationType == '2'">
                <div class="col-12 col-md-6 mr-3">

                    <CommonLabelContainer title="Konstruktion">
                        <div class="container-fluid p-0">
                            <div class="row">
                                <div class="col-12">
                                    För att spara data klickar du antingen på ”Spara” som finns på respektive rad eller knappen
                                    "Skapa värden i lönesystemet" som finns under tabellen.

                                    <table class="table table-light table-hover table-striped">
                                        <thead class="thead-light">
                                            <tr>
                                                <th class="col-4">Poäng fr.o.m.</th>
                                                <th class="col-4">Poäng t.o.m.</th>
                                                <th class="col-3">Värde kr</th>
                                                <th class="col-1"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(interval, index) in intervals" :key="index">
                                                <td>{{interval.From}}</td>
                                                <td>{{interval.To}}</td>
                                                <td>
                                                    <span v-decimal-text.max2="interval.Salary"></span>
                                                </td>
                                                <td>
                                                    <div class="pull-right" style="" v-if="disabled == false">
                                                        <div class="dropdown text-right pr-2">
                                                            <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                                ...
                                                            </a>
                                                            <div class="dropdown-menu dropdown-menu-right">
                                                                <a href="javascript:void(0)" class="dropdown-item" @click="updateInterval(interval)">Uppdatera</a>
                                                                <a href="javascript:void(0)" class="dropdown-item" @click="removeSalaryInterval(interval)">Ta bort</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Poäng fr.o.m" v-model="startPoint" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Poäng t.o.m" v-model="endPoint" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" label="Värde i kr" v-model="salary" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="createInterval">
                                        Skapa intervall
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </CommonLabelContainer>
                </div>
            </div>

            <div class="row" v-if="calculationType == '3'">
                <div class="col-12 col-md-6 mr-3">
                    <CommonLabelContainer title="Konstruktion">
                        <div class="container-fluid p-0">
                            <div class="row">
                                <div class="col-12">
                                    <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" label="Värde kr per poäng" v-model="blockSalaryPerPoint" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="updateSalariesWithPoint">
                                        Beräkna värde
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </CommonLabelContainer>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 mr-3 mt-3">
                    <v-select v-bind:disabled="disabled" bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="positions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 mr-3">
                    <b>Utfall</b>
                    <table class="mt-2 table table-light table-hover table-striped">
                        <thead class="thead-light">
                            <tr>
                                <th class="col-6">Befattning</th>
                                <th class="col-2" v-if="calculationType == '2' || calculationType == '3'">Poäng</th>
                                <th class="col-4">Värde kr</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in jobPositionBlocks" :key="index">
                                <td>{{row.Name}}</td>
                                <td v-if="calculationType == '2' || calculationType == '3'">{{row.Points}}</td>
                                <td>
                                    <span v-decimal-text.max2="row.Salary"></span>
                                </td>
                            </tr>
                        </tbody>

                    </table>
                    <div class="mt-3">Summa värde: {{getSumSalary(jobPositionBlocks)}}</div>
                </div>
            </div>

        </div>
        <WageSalaryInterval v-bind:disabled="disabled" :model="model" ref="updateSalaryInterval" @updated="updateAfterChange"></WageSalaryInterval>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import CommonLabelContainer from "../../common/common-label-container";
    import { getCurrentInstance } from 'vue'
    import WageSalaryInterval from './update/update-salary-interval.vue'
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'

    const updateSalaryInterval = ref(null);

    export default {
        emits: ['updated'],
        name: 'wage-money-position-salary',
        components: {
            CommonLabelContainer,
            WageSalaryInterval,
            CommonSpinner,
        },
        props: {
            model: Object,
            selectedJobPosition: String,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async changeType(type) {
                if (type === this.calculationType) {
                    return;
                }
                if (confirm("Om du byter alternativ kommer befintliga blockvärden att nollställas. Vill du byta alternativ?")) {
                    // getSalaryPart() körs i mounted utan await; ett långsamt svar kunde tidigare skriva över
                    // användarens val och dölja rätt Alt (flaky UI / E2E).
                    this.calculationTypeUserTouched = true;
                    this.loading++;
                    this.calculationType = type;
                    try {
                        await WageService.updateBlockWagepart(true, this.calculationType, this.blockSalary, this.blockSalaryPerPoint);
                        this.displaySnackBar("Sparat");
                        await this.refreshViews()
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            updateInterval(item) {
                this.loading++;
                this.updateSalaryInterval.open(item);
                this.loading--;
            },
            async removeSalaryInterval(item) {
                if (confirm(" Är du säker att du vill radera intervallet?")) {
                    this.loading++;
                    try {
                        await WageService.deleteSalaryInterval(item.SalaryIntervalId);
                        this.displaySnackBar("Borttaget");
                        this.updateAfterChange()
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async getPositionsWithPoints() {
                this.loading++;
                try {
                    this.positions = await WageService.getPositionsWithPoints();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async savePositionBlockSalary(positionBlock) {
                this.loading++;
                try {
                    await WageService.updatePositionBlockSalary(positionBlock);
                    this.displaySnackBar("Sparat");
                    this.updateAfterChange()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            setBlockPartSalary() {
                this.loading++;
                try {
                    this.updateAfterChange()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async setAllSalaries() {
                this.loading++;
                try {
                    await WageService.updatePositionBlockSalaries(this.jobPositionsWithBlocks);
                    this.displaySnackBar("Sparat");
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async updateAfterChange() {
                this.loading++;
                try {
                    await WageService.updateBlockWagepart(false, this.calculationType, this.blockSalary, this.blockSalaryPerPoint);
                    await this.refreshViews();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async refreshViews() {
                this.loading++;
                try {
                    if (this.calculationType == "1") {
                        await this.getJobPositionsWithBlocks();
                    }
                    else if (this.calculationType == "2") {
                        await this.loadIntervals();
                    }
                    if (this.selectedPosition != null) {
                        await this.getJobPositionBlocksPointSumAll(this.selectedPosition);
                    }
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadIntervals() {
                this.loading++;
                try {
                    this.intervals = await WageService.getSalaryInterval(1);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getJobPositionBlocksPointSumAll(jobPositionId) {
                this.loading++;
                try {
                    this.jobPositionBlocks = await WorkOrganisationService.getJobPositionBlocksPointSumAll(jobPositionId);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getSalaryPart() {
                this.loading++;
                try {
                    var salaryPart = await WageService.getWagePartBlock();
                    this.blockSalaryPerPoint = salaryPart.BlockSalaryPerPoint;
                    this.blockSalary = salaryPart.BlockSalary;
                    if (!this.calculationTypeUserTouched) {
                        this.calculationType = salaryPart.CalculationType.toString();
                    }
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getJobPositionsWithBlocks() {
                this.loading++;
                try {
                    var tmp = await WorkOrganisationService.getJobPositionsWithBlocks();
                    var latestPositionName = null;
                    for (var i = 0; i < tmp.length; i++) {
                        if (tmp[i].JobPositionName != latestPositionName)
                            latestPositionName = tmp[i].JobPositionName;
                        else
                            tmp[i].JobPositionName = null;
                    }
                    this.jobPositionsWithBlocks = tmp;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async createInterval() {
                this.loading++;
                try {
                    await WageService.addBlockSalaryInterval(this.startPoint, this.endPoint, this.salary);
                    this.displaySnackBar("Sparat");
                    this.updateAfterChange()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async updateSalariesWithPoint() {
                this.loading++;
                try {
                    this.updateAfterChange()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            getSumSalary(jobPositionBlocks) {
                var sum = 0;
                for (var i = 0; i < jobPositionBlocks.length; i++) {
                    sum += jobPositionBlocks[i].Salary;
                }
                return sum;
            },
            async printBlockSalary() {
                this.newWindow = window.open('/wagesettingsprint/PrintBlockSalary', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            async doUpdate(){
                this.loading++;
                try {
                    await this.updateAfterChange();
                    this.displaySnackBar("Uppdaterat");
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                jobPositionsWithBlocks:[],
                jobPositionBlocks:[],
                selectedPosition:null,
                intervals:[],
                startPoint: null,
                endPoint: null,
                blockSalary: null,
                blockSalaryPerPoint: null,
                calculationType: "0",
                /** Sätts när användaren bekräftat byte av beräkningstyp; stoppar sent getSalaryPart-svar från att kasta om Alt. */
                calculationTypeUserTouched: false,
                positions: [],
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedPosition: function (newVal) {
                this.getJobPositionBlocksPointSumAll(newVal);
                this.$emit('positionSelected', newVal)
            },
        },
        mounted() {
            this.selectedPosition = this.selectedJobPosition;
            this.getPositionsWithPoints();
            this.getJobPositionsWithBlocks();
            this.getSalaryPart();
            
        },

        // eslint-disable-next-line
        setup(props, { emit }) {
            return { updateSalaryInterval }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
